import React from 'react';
import styled from 'styled-components';
import { slate1, white } from '@engage/colors';
import { If } from '@engage/conditional-render';
import { spaces } from '@engage/styles';
import { capsLabel5Large } from '@engage/typography';
import { ClassesCopy } from '@members/copy';
import { Classes } from '@members/copy/models.generated/Classes';
import Filter from '../icons/Filter';

type Props = {
  appliedFilterCount: number;
};

const FilterButtonContent: React.FC<React.PropsWithChildren<Props>> = ({
  appliedFilterCount,
}) => (
  <Container>
    <If condition={appliedFilterCount === 0}>
      <FilterIcon />
    </If>
    <If condition={appliedFilterCount > 0}>
      <AppliedCount data-test-id="filterCount" aria-hidden={true}>
        {appliedFilterCount}
      </AppliedCount>
    </If>
    <ButtonText>
      <ClassesCopy id={Classes.Filter} />
    </ButtonText>
  </Container>
);

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ButtonText = styled.span`
  line-height: 1;
`;

const FilterIcon = styled(Filter)`
  height: ${spaces.medium}px;
  margin-right: 10px;
  width: ${spaces.medium}px;
  margin-top: 1px;
`;

const AppliedCount = styled.div`
  background-color: ${slate1};
  ${capsLabel5Large}
  padding: ${spaces.tiny}px;
  color: ${white};
  text-align: center;
  line-height: 1em;
  height: ${spaces.medium}px;
  width: ${spaces.medium}px;
  border-radius: 50%;
  margin-right: 10px;
`;

export default FilterButtonContent;
